import PropTypes from "prop-types";

const TrendLine = ({ data = [], color = "#00BA07" }) => {
  // Coerce to numbers and drop non-finite values to prevent NaN in path
  const numericData = Array.isArray(data)
    ? data
        .map((v) => (typeof v === "string" ? Number(v) : v))
        .filter((v) => Number.isFinite(v))
    : [];

  const sortedData = [...numericData].sort((a, b) => a - b);

  if (sortedData.length < 2)
    return (
      <svg
        className="w-full h-full"
        viewBox="0 0 200 60"
        preserveAspectRatio="none">
        <path d="M0 30 L200 30" fill="none" stroke={color} strokeWidth="2" />
      </svg>
    );

  // Generate points with proper coordinates
  const maxValue = Math.max(...sortedData);
  const safeMax = Number.isFinite(maxValue) && maxValue > 0 ? maxValue : 1;

  const points = sortedData.map((value, index) => ({
    x: (index / (sortedData.length - 1)) * 200,
    y: 60 - (value / safeMax) * 40,
  }));

  // Create SVG path with cubic Bézier curves
  let pathD = `M ${points[0].x} ${points[0].y}`;

  for (let i = 0; i < points.length - 1; i++) {
    const current = points[i];
    const next = points[i + 1];

    // Calculate control points for smooth curve
    const controlPoint1X = current.x + (next.x - current.x) / 3;
    const controlPoint2X = current.x + ((next.x - current.x) * 2) / 3;

    pathD += ` C ${controlPoint1X} ${current.y}, ${controlPoint2X} ${next.y}, ${next.x} ${next.y}`;
  }

  return (
    <svg
      className="w-full h-full"
      viewBox="0 0 200 60"
      preserveAspectRatio="none">
      <path d={pathD} fill="none" stroke={color} strokeWidth="2" />
    </svg>
  );
};

export default TrendLine;

TrendLine.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  ),
  color: PropTypes.string,
};
